module.exports = __webpack_public_path__ + "static/media/blueflowers.6aeefd14.svg";